export class ContentTooLargeError extends Error {
  constructor(message?: string) {
    super(message);

    // Restore prototype chain for target ES5
    Object.setPrototypeOf(this, ContentTooLargeError.prototype);
  }
}
